module.exports = __webpack_public_path__ + "static/project2-18fd1505b6ab6d1262696bc6c0a6d43d.jpg";